import { render, staticRenderFns } from "./FunctionPackage.vue?vue&type=template&id=2c549a56&scoped=true"
import script from "./FunctionPackage.vue?vue&type=script&lang=js"
export * from "./FunctionPackage.vue?vue&type=script&lang=js"
import style0 from "./FunctionPackage.vue?vue&type=style&index=0&id=2c549a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c549a56",
  null
  
)

export default component.exports